import type { AxiosResponse } from 'axios';

import axiosInstance from '../../instance';
import ROUTES from '../../routes';
import type { IPark } from './types';

export const getAll = ()
  : Promise<void | AxiosResponse<IPark []>> => axiosInstance({
  url: `${ROUTES.PARKS}`,
  method: 'GET',
  headers: {
    authorization: true,
  },
});
